module.exports = {
      id: "infographer-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#infographer",
      toString: function () {
        return this.url;
      }
    }